import { ColumnDef } from '@tanstack/react-table';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Icon } from '../Icon';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const expandableHeader: ColumnDef<any> = {
  accessorKey: '_expand',
  header: '',
  cell: ({ row }) => {
    if (!row.getCanExpand()) {
      return null;
    }

    const toggleExpansion = row.getToggleExpandedHandler();

    return (
      <div onClick={toggleExpansion} className="cursor-pointer" style={{ paddingInlineStart: row.depth * 8 }}>
        <Icon type={row.getIsExpanded() ? ChevronDown : ChevronRight} />
      </div>
    );
  }
};
